export class Page {
    size = 0;
    totalElements = 0;
    totalPages = 0;
    pageNumber = 0;
    number = 0;
}